import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { SubdomainHome } from './types';

export function useSubdomainHomeData(): Page<SubdomainHome> {
  return useCurrentPage<Page<SubdomainHome>>();
}
